const VARIANT_ID_RESOLVE_PATH = 'apps/bc/variant/by-sku';
const ID_MAPPING = [
  {
    sku: "RÄNNIKAAPELI",
    id: 55690130424190,
    parent_id: 15406374322558
  },
  {
    sku: "SULANAPITO",
    id: 55690132226430,
    parent_id: 15406377599358
  }
]

class PSTConfigurableCartService {

  qtyBubble = null

  constructor() {
    this.qtyBubble = document.querySelector('.cart-count-bubble');
  }

  async addConfigurableToCart(data) {
    const normSku = (s) => (s ?? '').toString().trim().toUpperCase()

    // Workaround for mixed configuration requests coming from frontend:
    // If `configuration_sku` is SULANAPITO but a main-level configuration item contains SKU 8179495,
    // add that item to cart using the RÄNNIKAAPELI configurable variant id.
    const isSulanapitoRequest = normSku(data?.configuration_sku) === 'SULANAPITO'
    const needsRannikaapeliSplitSku = '8179495'

    const simpleItemRequests = data.items.filter(item => (!item.items || item.items.length === 0) && item.sku)
    const configurationItemRequests = data.items.filter(item => item.items && item.items.length > 0)
    // Loop through each configuration item and add to cart
    const configurationItems = await Promise.all(configurationItemRequests.map(async (configurationItem) => {
      const mappingSku = (isSulanapitoRequest && normSku(configurationItem?.sku).includes(normSku(needsRannikaapeliSplitSku)))
        ? 'RÄNNIKAAPELI'
        : data.configuration_sku
      const idMapping = ID_MAPPING.find(mapping => mapping.sku === mappingSku)
      if (!idMapping) {
        throw new Error(`No ID mapping found for SKU: ${mappingSku}`)
      }
      const extraProperties = {
        Sulanapitokaapeli: `${configurationItem?.name} - ${configurationItem?.size} m` || '',
        ...(configurationItem?.items && configurationItem?.items.length > 0 && {
          Liitoskaapeli: `${configurationItem?.items[0]?.name} - ${configurationItem?.items[0]?.size} m` || '' // @TODO: If theres different types of configurables should handle this differently
        }),
        Positio: configurationItem?.position || ''
      }
      return {
        id: idMapping.id,
        quantity: configurationItem.amount,
        properties: {
          _vividworks_configurable: true,
          _vividworks_configuration: JSON.stringify(configurationItem),
          _vividworks_configuration_hash: await hashConfigurationItem(configurationItem),
          _vividworks_configurable_sku: idMapping.sku,
          ...extraProperties
        }
      }
    }))
    const response = await fetch(`/${VARIANT_ID_RESOLVE_PATH}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        skus: simpleItemRequests.map(item => item.sku)
      })
    });
    const variantIds = await response.json();

    const simpleItems = simpleItemRequests.map((item, index) => ({
      id: variantIds.find(variant => variant.sku === item.sku)?.id,
      quantity: item.amount,
      properties: {
        _vividworks_configurable_addon: true
      }
    })).filter(item => item.id); // Remove items that don't have a variant id
    const addToCart = []
    if (configurationItems && configurationItems.length > 0) {
      addToCart.push(...configurationItems)
    }
    if (simpleItems && simpleItems.length > 0) {
      addToCart.push(...simpleItems)
    }
    return this.addToCart(addToCart)
  }

  async addToCart(items) {
    console.log(`Add configurable items in cart: ${JSON.stringify(items)}`)
    const config = fetchConfig('javascript');
    config['body'] = JSON.stringify({items, sections: 'cart-icon-bubble'});
    try {
      const response = await fetch(`${routes.cart_add_url}`, config)
      const data = await response.json()
      this.updateQtyBubbleFromResponse(data);
      return data
    } catch (e) {
      console.error(e)
    }
  }

  updateQtyBubbleFromResponse(response) {
    const html = new DOMParser().parseFromString(
      response.sections['cart-icon-bubble'],
      'text/html',
    );
    const sourceQtyBubble = html.querySelector('.cart-count-bubble');

    this.qtyBubble.innerHTML = sourceQtyBubble.innerHTML;
  }
}

window.PSTConfigurableCartService = new PSTConfigurableCartService()


/**
 * Convert ArrayBuffer to hex string.
 */
function bufferToHex(buffer) {
  const bytes = new Uint8Array(buffer)
  let hex = ''
  for (let i = 0; i < bytes.length; i++) {
    hex += bytes[i].toString(16).padStart(2, '0')
  }
  return hex
}

/**
 * Hash a configuration item using SHA-256 in the browser.
 * Returns a hex string.
 */
async function hashConfigurationItem(configurationItem) {
  const payload = {
    configuration: configurationItem,
    nonce: Date.now()
  }
  const normalized = JSON.stringify(payload)
  const data = new TextEncoder().encode(normalized)
  const digest = await crypto.subtle.digest('SHA-256', data)
  return bufferToHex(digest)

}
